import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetBusinessOrganizationPricingConfigDocument = gql`
  query GetBusinessOrganizationPricingConfig {
    getBusinessOrganizationPricingConfig {
      bookmarking_enabled
      cost_change_lookback_mode
      cost_change_week_anchor_day
      currency_code
      customer_table_enabled
      peer_range_column_enabled
      pricing_agent_enabled
      pricing_management_enabled
      show_invoice_history_popover
      timezone
    }
  }
`;
export function useGetBusinessOrganizationPricingConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >(GetBusinessOrganizationPricingConfigDocument, options);
}
export function useGetBusinessOrganizationPricingConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >(GetBusinessOrganizationPricingConfigDocument, options);
}
export type GetBusinessOrganizationPricingConfigQueryHookResult = ReturnType<
  typeof useGetBusinessOrganizationPricingConfigQuery
>;
export type GetBusinessOrganizationPricingConfigLazyQueryHookResult =
  ReturnType<typeof useGetBusinessOrganizationPricingConfigLazyQuery>;
export type GetBusinessOrganizationPricingConfigQueryResult =
  Apollo.QueryResult<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >;

/**
 * Wrapped version of useGeneratedGetBusinessOrganizationPricingConfigQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetBusinessOrganizationPricingConfigQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >(GetBusinessOrganizationPricingConfigDocument, options);
}

/**
 * Wrapped version of useGeneratedGetBusinessOrganizationPricingConfigLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetBusinessOrganizationPricingConfigLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetBusinessOrganizationPricingConfigQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetBusinessOrganizationPricingConfigQuery,
    Types.GetBusinessOrganizationPricingConfigQueryVariables
  >(GetBusinessOrganizationPricingConfigDocument, lazyOptions);
}
